module.exports = __webpack_public_path__ + "img/skin1.ff81d020.jpg";